import React from "react";
import { useLanguage } from "../context/LanguageContext";
import "./../css/vision.scss";

const Vision: React.FC = () => {
  const { data, lang } = useLanguage();

  const title = lang === 'en' ? "SYSTEM ARCHITECTURE PRINCIPLES" : "PRINCIPIOS DE ARQUITECTURA DE SISTEMAS";
  const footer = lang === 'en'
    ? '"Build for resilience. Engineer for sovereignty. Optimize for the metal."'
    : '"Construye para la resiliencia. Diseña para la soberanía. Optimiza para el metal."';

  return (
    <div className="px-2 py-3 vision-manifesto">
      <div className="info-container">
        <h4 className="fw-bold mb-4">{title}</h4>

        <div className="manifesto-content">
          {data.manifesto.map((point, index) => (
            <div key={index} className="mb-4 animate-in" style={{ animationDelay: `${index * 200}ms` }}>
              <h6 className="fw-bold mb-2">
                {`PRINCIPLE_0${index + 1}: ${point.principle}`}
              </h6>
              <p>
                {point.statement}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-5 pt-3 border-top">
          <p className="font-italic">
            {footer}
          </p>
        </div>
      </div>

      <style>{`
        .vision-manifesto .animate-in {
          opacity: 0;
          transform: translateY(10px);
          animation: fadeUp 0.6s forwards;
        }
        @keyframes fadeUp {
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default Vision;
